/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EntityType = {
    hub: 'hub',
    quest: 'quest',
    competition: 'competition',
    loot_shop: 'loot_shop',
    activation: 'activation',
    cockpit: 'cockpit',
    game: 'game',
    drop: 'drop',
    placement: 'placement'
} as const;
export type EntityType = typeof EntityType[keyof typeof EntityType];


export function instanceOfEntityType(value: any): boolean {
    for (const key in EntityType) {
        if (Object.prototype.hasOwnProperty.call(EntityType, key)) {
            if (EntityType[key as keyof typeof EntityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EntityTypeFromJSON(json: any): EntityType {
    return EntityTypeFromJSONTyped(json, false);
}

export function EntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityType {
    return json as EntityType;
}

export function EntityTypeToJSON(value?: EntityType | null): any {
    return value as any;
}

export function EntityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): EntityType {
    return value as EntityType;
}

